import React, { Component } from 'react'
import SimpleTabs from '../components/Tabs/InfinitoTabsPanel'

class InfinitoTab extends Component {
    render() {
        return (
            <div>
                <SimpleTabs />
            </div>
        )
    }
}

  export default InfinitoTab;